<template>
  <div class="form-filter">
    <div class="form-block">
      <div class="flex flex-col fl-1 m-b-8">
        <label for="name" class="small-label">Название сегмента*</label>
        <SceletonInput :is-loading="isLoadingData">
          <InputText
            id="name"
            placeholder="Введите название"
            v-model="segment.name"
            :disabled="isSegmentSetted"
          />
        </SceletonInput>
      </div>

      <div class="flex flex-col fl-1 m-t-8 m-b-8 none">
        <label for="type" class="small-label">Тип сегмента*</label>
        <Dropdown
          id="type"
          @change="onTypeChange"
          placeholder="Выберите тип сегмента"
          v-model="segment.type"
          :options="types"
          optionLabel="name"
          aria-describedby="type-help"
          :disabled="isSegmentSetted"
        />
      </div>

      <div class="info-block flex">
        <span class="pi pi-info-circle info"></span>
        <div class="text">
          Численность аудитории с учетом правил комбинирования сегмента и
          указанных выборок покажет вам количество уникальных юзеров, попавших в
          выборку.
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="form-block fl-50 m-r-13">
        <div class="flex flex-col fl-1">
          <div class="flex fl-jc-sb m-b-8 fl-1">
            <div>
              <label>Точная дата</label>
              <span
                class="pi pi-info-circle icon-right"
                v-tooltip="{
                  value:
                    'При выборе этого типа сегмент будет собираться только в рамках указанных дат. Если выбрана дата окончания, то он расчитается один раз и далее обновляться не будет. Если дата окончания не выбрана, то сегмент будет рассчитан и обновлен от даты начала до текущей даты.',
                  class: 'white-tooltip',
                }"
              ></span>
            </div>

            <InputSwitch
              v-model="segment.conditionsGroups[0].isFixedDate"
              :disabled="isSegmentSetted"
              @change="
                segment.conditionsGroups[0].isFlexibleDate =
                  !segment.conditionsGroups[0].isFixedDate
              "
              inputId="updated"
            />
          </div>
          <div class="flex flex-col m-b-8">
            <label for="period" class="small-label"
              >Период покупки от<span
                v-if="segment.conditionsGroups[0].isFixedDate"
                >*</span
              ></label
            >
            <SceletonInput :is-loading="isLoadingData">
              <CalendarInput
                :modelValue="segment.conditionsGroups[0].period.start"
                @update:modelValue="
                  ($event) =>
                    (segment.conditionsGroups[0].period.start = $event)
                "
                :disabled="
                  isSegmentSetted || segment.conditionsGroups[0].isFlexibleDate
                "
              ></CalendarInput>
            </SceletonInput>
          </div>
          <div class="flex flex-col">
            <label for="period" class="small-label">Период покупки до</label>
            <SceletonInput :is-loading="isLoadingData">
              <CalendarInput
                :modelValue="segment.conditionsGroups[0].period.end"
                @update:modelValue="
                  ($event) => (segment.conditionsGroups[0].period.end = $event)
                "
                :disabled="
                  isSegmentSetted || segment.conditionsGroups[0].isFlexibleDate
                "
              ></CalendarInput>
            </SceletonInput>
          </div>
        </div>
      </div>
      <div class="form-block fl-50 m-l-13">
        <div class="flex flex-col">
          <div class="flex fl-jc-sb m-b-7">
            <div>
              <label class="fl-1"
                >Смещение от текущей даты в меньшую сторону</label
              >
              <span
                class="pi pi-info-circle icon-right"
                v-tooltip="{
                  value:
                    'Смещение `начало периода` означает нижнюю границу периода выборки, `окончание периода` - верхнюю. Например, от минус трех месяцев (начало периода) до минус одного месяца (окончание периода) означает, что если сегодня 1 мая, то данные будут собраны от 1 февраля до 1 апреля. Такой сегмент каждый раз будет обновляться со сдвигом даты относительно текущей. Если дата окончания не указана, то концом периода будет считаться текущая дата. ',
                  class: 'white-tooltip',
                }"
              ></span>
            </div>
            <InputSwitch
              v-model="segment.conditionsGroups[0].isFlexibleDate"
              :disabled="isSegmentSetted"
              inputId="updated"
              @change="
                segment.conditionsGroups[0].isFixedDate =
                  !segment.conditionsGroups[0].isFlexibleDate
              "
            />
          </div>
          <div class="flex flex-col fl-1 m-b-7">
            <label class="small-label"
              >Начало периода<span v-if="segment.conditionsGroups[0].isFlexibleDate"
                >*</span
              ></label
            >
            <SceletonInput :is-loading="isLoadingData">
              <InputInterval
                :disabled="
                  isSegmentSetted || segment.conditionsGroups[0].isFixedDate
                "
                :modelValue="segment.conditionsGroups[0].flexible_period.start"
                @update:modelValue="
                  ($event) =>
                    (segment.conditionsGroups[0].flexible_period.start = $event)
                "
              ></InputInterval>
            </SceletonInput>
          </div>
          <div class="flex flex-col fl-1">
            <label class="small-label">Окончание периода</label>
            <SceletonInput :is-loading="isLoadingData">
              <InputInterval
                :disabled="
                  isSegmentSetted || segment.conditionsGroups[0].isFixedDate
                "
                :modelValue="segment.conditionsGroups[0].flexible_period.end"
                @update:modelValue="
                  ($event) =>
                    (segment.conditionsGroups[0].flexible_period.end = $event)
                "
              ></InputInterval>
            </SceletonInput>
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <label class="small-label">Фильтр по полу*</label>

      <div class="gender-filter-section">
        <div class="female-male-container">
          <div class="gender-option">
            <Checkbox
              v-model="maleCheckbox"
              binary
              input-id="maleCheckbox"
              :disabled="isSegmentSetted"
            />
            <label for="maleCheckbox" class="gender-checkbox-label"
              >Мужчины</label
            >
          </div>

          <div class="gender-option">
            <Checkbox
              v-model="femaleCheckbox"
              binary
              input-id="femaleCheckbox"
              :disabled="isSegmentSetted"
            />
            <label for="femaleCheckbox" class="gender-checkbox-label"
              >Женщины</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <label class="small-label">Фильтр по возрасту*</label>

      <div class="gender-filter-section">
        <div class="age-container">
          <div class="gender-option">
            <Checkbox
              v-model="allAgesCheckbox"
              binary
              input-id="allAgesCheckbox"
              :disabled="isSegmentSetted"
            />
            <label for="allAgesCheckbox" class="gender-checkbox-label"
              >Все</label
            >
          </div>
          <div class="age-divider"></div>
          <div
            v-for="option in ageOptions"
            :key="option.value"
            class="gender-option"
          >
            <Checkbox
              :model-value="
                segment.conditionsGroups[0].age.includes(option.value)
              "
              @update:model-value="(value: boolean) => {
                segment.conditionsGroups[0].age = toggleAgeValue(
                  segment.conditionsGroups[0].age,
                  option.value
                );
              }"
              binary
              :input-id="`ageCheckbox${option.value}`"
              :disabled="isSegmentSetted"
            />
            <label
              :for="`ageCheckbox${option.value}`"
              class="gender-checkbox-label"
              >{{ option.label }}</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="flex flex-col">
        <label for="state" class="small-label">Категория</label>
        <Skeleton height="2.2rem" class="mb-2" v-if="isLoadingData"></Skeleton>
        <CategoryTreeInput
          :class="[isLoadingData ? 'none' : '']"
          :modelValue="segment.conditionsGroups[0].category"
          ref="childCategoryTree"
          :isSegmentSetted="isSegmentSetted"
          @update:modelValue="
            ($event: any) => (segment.conditionsGroups[0].category = $event)
          "
        ></CategoryTreeInput>
      </div>
    </div>

    <div
      class="form-block"
      v-if="segment.type.value != 'probability_of_purchase'"
    >
      <div class="flex some-inputs">
        <div class="flex flex-col m-r-8 input-container">
          <label for="period" class="small-label">Бренд</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataBaseInput
              selectType="brand"
              :isSegmentSetted="isSegmentSetted"
              :modelValue="segment.conditionsGroups[0].brand"
              @update:modelValue="
                ($event) => (segment.conditionsGroups[0].brand = $event)
              "
            ></CatalogDataBaseInput>
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label for="period" class="small-label">Магазин</label>
          <SceletonInput :is-loading="isLoadingData">
            <CatalogDataBaseInput
              selectType="segment_shop"
              :isSegmentSetted="isSegmentSetted"
              :modelValue="segment.conditionsGroups[0].shop"
              @update:modelValue="
                ($event) => (segment.conditionsGroups[0].shop = $event)
              "
            ></CatalogDataBaseInput>
          </SceletonInput>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="flex some-inputs">
        <div class="flex flex-col m-r-8 input-container">
          <label for="total" class="small-label">Сумма чека от</label>
          <SceletonInput :is-loading="isLoadingData">
            <DecimalNumberInput
              input-id="total"
              v-model="segment.conditionsGroups[0].total"
              placeholder="Введите сумму"
              :min="0"
              :disabled="isSegmentSetted"
              :invalid="showTotalRangeInvalid"
              @focus="onTotalRangeFocus"
              @blur="onTotalRangeBlur"
            />
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label for="maxTotal" class="small-label">Сумма чека до</label>
          <SceletonInput :is-loading="isLoadingData">
            <DecimalNumberInput
              input-id="maxTotal"
              v-model="segment.conditionsGroups[0].maxTotal"
              placeholder="Введите сумму"
              :min="0"
              :disabled="isSegmentSetted"
              :invalid="showTotalRangeInvalid"
              @focus="onTotalRangeFocus"
              @blur="onTotalRangeBlur"
            />
          </SceletonInput>
        </div>
      </div>
      <div v-if="totalRangeError" class="field-error flex m-t-8">
        <span class="pi pi-exclamation-circle"></span>
        <div class="text">{{ totalRangeError }}</div>
      </div>
      <div v-else class="info-block flex m-t-8">
        <span class="pi pi-info-circle info"></span>
        <div class="text">
          Можно указать только нижнюю, только верхнюю или обе границы суммы
          чека. Пустые поля не учитываются.
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="flex some-inputs">
        <div class="flex flex-col m-r-8 input-container">
          <label for="minPurchasesCount" class="small-label"
            >Кол-во чеков от</label
          >
          <SceletonInput :is-loading="isLoadingData">
            <InputNumber
              inputId="minPurchasesCount"
              v-model="segment.conditionsGroups[0].minPurchasesCount"
              placeholder="Не меньше 2"
              :min="2"
              :minFractionDigits="0"
              :maxFractionDigits="0"
              :useGrouping="false"
              :disabled="isSegmentSetted"
              :class="['w-full', { 'p-invalid': showPurchasesRangeInvalid }]"
              @focus="onPurchasesRangeFocus"
              @blur="onPurchasesRangeBlur"
            />
          </SceletonInput>
        </div>
        <div class="flex flex-col input-container">
          <label for="maxPurchasesCount" class="small-label"
            >Кол-во чеков до</label
          >
          <SceletonInput :is-loading="isLoadingData">
            <InputNumber
              inputId="maxPurchasesCount"
              v-model="segment.conditionsGroups[0].maxPurchasesCount"
              placeholder="Не меньше 2"
              :min="2"
              :minFractionDigits="0"
              :maxFractionDigits="0"
              :useGrouping="false"
              :disabled="isSegmentSetted"
              :class="['w-full', { 'p-invalid': showPurchasesRangeInvalid }]"
              @focus="onPurchasesRangeFocus"
              @blur="onPurchasesRangeBlur"
            />
          </SceletonInput>
        </div>
      </div>
      <div v-if="purchasesBoundsError" class="field-error flex m-t-8">
        <span class="pi pi-exclamation-circle"></span>
        <div class="text">{{ purchasesBoundsError }}</div>
      </div>
      <div v-else class="info-block flex m-t-8">
        <span class="pi pi-info-circle info"></span>
        <div class="text">
          Можно указать только нижнюю, только верхнюю или обе границы числа
          покупок. Минимальное значение — 2.
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="info-block alone flex">
        <span class="pi pi-info-circle info"></span>
        <div class="text">
          <p>
            Для расчёта аудитории и сохранения сегмента обязательными полями
            являются название, период, фильтр по полу и возрасту. Также
            необходимо выбрать одно или несколько условий выборки (категория,
            бренд, магазин, стоимость чека, число покупок). Если указать два
            условия или более, то по ним произойдёт пересечение аудиторий
            (работает как "И").
          </p>
          <p>Перед сохранением сегмента обновите счётчик аудитории.</p>
        </div>
      </div>
    </div>
  </div>
  <ChangeSegmentPageDialog
    :visible="confirmVisible"
    :blocked="blockedRouterButton"
    :isSegmentSetted="isSegmentSetted"
    @exit="exitLeaveDialog"
    @create-segment="createSegmentFromDialog"
  ></ChangeSegmentPageDialog>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  GENDER_VALUES,
  toggleGenderValue,
  createAgeMappings,
  toggleAgeValue,
} from "@/services/segments/utils";
import { useAgesStore } from "@/store/catalog_data/ages";

import Checkbox from "primevue/checkbox";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import InputInterval from "./InputInterval.vue";
import ChangeSegmentPageDialog from "@/entities/segments/dialogs/ChangeSegmentPageDialog.vue";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import CategoryTreeInput from "@/entities/segments/forms/CategoryTreeInput.vue";
import CalendarInput from "./CalendarInput.vue";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import DecimalNumberInput from "@/shared/forms/DecimalNumberInput.vue";
import Skeleton from "primevue/skeleton";

import { rootGetters } from "@/main";
import { onBeforeRouteLeave } from "vue-router";
import { SegmentFilter, ConditionsGroup } from "@/services/segments/filters";
import {
  hasModifiedConditions,
  validateSegmentBounds,
  validatePurchasesBounds,
  validateTotalRange,
  getCountDisabledReason,
} from "@/services/segments/utils";
import { useSegmentsStore } from "@/store/segments/segments";
import { useCategoriesStore } from "@/store/catalog_data/categories";
import { getFilterWithCategories } from "@/services/utils/Objects";
import {
  isValidPeriod,
  isValidFlexiblePeriod,
} from "@/services/utils/DateValidator";

const emit = defineEmits([
  "setCreateButton",
  "setLoading",
  "setFilter",
  "updateIsReadyToCount",
  "updateCountDisabledReason",
  "updateAudienceCount",
  "updateSegmentCost",
]);
const props = defineProps<{
  isLoading: boolean;
  audienceCount: number | null;
  segmentCost: number | null;
}>();

const router = useRouter();
const route = useRoute();
const segmentStore = useSegmentsStore();
const categoryStore = useCategoriesStore();
const agesStore = useAgesStore();
const isLoadingData = ref(false);

// Computed свойства для чекбоксов gender
const maleCheckbox = computed({
  get: () =>
    segment.value.conditionsGroups[0].gender.includes(GENDER_VALUES.MALE),
  set: (value: boolean) => {
    segment.value.conditionsGroups[0].gender = toggleGenderValue(
      segment.value.conditionsGroups[0].gender,
      GENDER_VALUES.MALE
    );
  },
});

const femaleCheckbox = computed({
  get: () =>
    segment.value.conditionsGroups[0].gender.includes(GENDER_VALUES.FEMALE),
  set: (value: boolean) => {
    segment.value.conditionsGroups[0].gender = toggleGenderValue(
      segment.value.conditionsGroups[0].gender,
      GENDER_VALUES.FEMALE
    );
  },
});

// Опции для возраста из store
const ageOptions = computed(() => {
  return agesStore.itemList.map((age) => ({
    value: age.id,
    label: age.type,
  }));
});

// Computed свойство для чекбокса "Все" возрастов
const allAgesCheckbox = computed({
  get: () => {
    if (ageOptions.value.length === 0) return false;
    const allAgeIds = ageOptions.value.map((opt) => opt.value);
    const selectedAges = segment.value.conditionsGroups[0].age;
    return (
      allAgeIds.length > 0 && allAgeIds.every((id) => selectedAges.includes(id))
    );
  },
  set: (value: boolean) => {
    if (value) {
      segment.value.conditionsGroups[0].age = ageOptions.value.map(
        (opt) => opt.value
      );
    } else {
      segment.value.conditionsGroups[0].age = [];
    }
  },
});

const types = ref([
  { name: "Фильтр аудитории", value: "audience_filter" },
  { name: "Вероятность покупки", value: "probability_of_purchase" },
]);

const segment = ref({
  name: "",
  type: types.value[0],
  conditionsGroups: [
    {
      period: {
        start: null,
        end: null,
      },
      flexible_period: {
        start: {
          interval: 0,
          unit: "DAY",
        },
        end: {
          interval: 0,
          unit: "DAY",
        },
      },
      category: [] as any[],
      brand: [] as string[],
      shop: [] as string[],
      gender: [] as number[],
      age: [] as number[],
      total: null as number | null,
      maxTotal: null as number | null,
      minPurchasesCount: null as number | null,
      maxPurchasesCount: null as number | null,
      isFixedDate: true,
      isFlexibleDate: false,
    },
  ],
});

const filter = new SegmentFilter();
const ignoreWatch = ref(false);
const confirmVisible = ref(false);
const blockedRouterButton = ref(false);
const isButtonenabled = computed(() => {
  return (
    hasModifiedConditions(segment.value.conditionsGroups) &&
    validateSegmentBounds(segment.value.conditionsGroups[0]) === null &&
    segment.value.name.length > 0 &&
    !isSegmentSetted.value
  );
});
const countDisabledReason = computed(() =>
  getCountDisabledReason(segment.value.conditionsGroups)
);
const isReadyToCount = computed(() => countDisabledReason.value === null);
const purchasesBoundsError = computed(() =>
  validatePurchasesBounds(segment.value.conditionsGroups[0])
);
const totalRangeError = computed(() =>
  validateTotalRange(segment.value.conditionsGroups[0])
);
const totalRangeFocused = ref(false);
const purchasesRangeFocused = ref(false);
let totalRangeBlurTimer: ReturnType<typeof setTimeout> | null = null;
let purchasesRangeBlurTimer: ReturnType<typeof setTimeout> | null = null;

const showTotalRangeInvalid = computed(
  () => totalRangeError.value != null && !totalRangeFocused.value
);
const showPurchasesRangeInvalid = computed(
  () => purchasesBoundsError.value != null && !purchasesRangeFocused.value
);

function onTotalRangeFocus() {
  if (totalRangeBlurTimer) {
    clearTimeout(totalRangeBlurTimer);
    totalRangeBlurTimer = null;
  }
  totalRangeFocused.value = true;
}

function onTotalRangeBlur() {
  totalRangeBlurTimer = setTimeout(() => {
    totalRangeFocused.value = false;
  }, 120);
}

function onPurchasesRangeFocus() {
  if (purchasesRangeBlurTimer) {
    clearTimeout(purchasesRangeBlurTimer);
    purchasesRangeBlurTimer = null;
  }
  purchasesRangeFocused.value = true;
}

function onPurchasesRangeBlur() {
  purchasesRangeBlurTimer = setTimeout(() => {
    purchasesRangeFocused.value = false;
  }, 120);
}

const isSegmentSetted = computed(() => {
  return Boolean(route.params.id);
});
const toRouter = ref();
const childCategoryTree = ref(null);

watch(
  () => segment.value,
  (newValue) => {
    const ageMappings =
      agesStore.itemList.length > 0
        ? createAgeMappings(agesStore.itemList)
        : undefined;
    if (!ignoreWatch.value) {
      filter.setFilterBySegment(newValue, ageMappings);
    }
    if (!ignoreWatch.value && !isSegmentSetted.value) {
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    }
    sendFilterToParent();
  },
  { deep: true }
);

watch(
  isButtonenabled,
  () => {
    emit("setCreateButton", isButtonenabled);
  },
  { immediate: true }
);

onBeforeRouteLeave((to, from) => {
  if (isButtonenabled.value && !confirmVisible.value && !props.isLoading) {
    confirmLeaving();
    toRouter.value = to;
    return false;
  }
  return true;
});

onMounted(async () => {
  if (agesStore.itemList.length === 0) {
    await agesStore.getItems("", [], true, false, 0, 50, true);
  }

  // дублирование
  if (segmentStore.duplicatedSegmentId > 0) {
    setSegmentById(segmentStore.duplicatedSegmentId, true);
    segmentStore.duplicatedSegmentId = 0;
  }

  //сегмент по id для просмотра
  if (isSegmentSetted.value) {
    setSegmentById(parseInt(route.params.id as string), false);
  }

  // сегмент из url
  const filterStr = route.query.filter?.toString();
  const hasFilterFromUrl =
    filterStr && filterStr.length > 2 && filterStr !== "()";

  if (hasFilterFromUrl && filterStr) {
    ignoreWatch.value = true;
    filter.setFilterByStr(filterStr);
    const ageMappings =
      agesStore.itemList.length > 0
        ? createAgeMappings(agesStore.itemList)
        : undefined;
    setFilterGroup(filter.getSegmentConditionsByFilter(undefined, ageMappings));
    applyPurchasesBounds(
      route.query.min_purchases_count,
      route.query.max_purchases_count
    );
    ignoreWatch.value = false;
  } else if (
    route.query.min_purchases_count ||
    route.query.max_purchases_count
  ) {
    ignoreWatch.value = true;
    applyPurchasesBounds(
      route.query.min_purchases_count,
      route.query.max_purchases_count
    );
    ignoreWatch.value = false;
  }

  if (!isSegmentSetted.value && !hasFilterFromUrl) {
    if (
      segment.value.conditionsGroups[0].age.length === 0 &&
      agesStore.itemList.length > 0
    ) {
      segment.value.conditionsGroups[0].age = agesStore.itemList.map(
        (age) => age.id
      );
    }

    if (segment.value.conditionsGroups[0].gender.length === 0) {
      segment.value.conditionsGroups[0].gender = [0, 1];
    }
  }

  if (route.query.type) {
    segment.value.type = types.value.filter(
      (t) => t.value == route.query.type?.toString()
    )[0];
  } else if (route.name == "segmentCreate") {
    if (filter.stringFilter != "()")
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    else {
      router.replace({
        name: "segmentCreate",
        query: buildCreateQuery(),
      });
    }
  }

  if (!hasFilterFromUrl) {
    Promise.resolve().then(() => {
      ignoreWatch.value = false;
    });
  }
});

const setFilterGroup = (groups: ConditionsGroup[]) => {
  if (childCategoryTree.value)
    childCategoryTree.value.loadChoosenValues(groups[0].category);
  segment.value.conditionsGroups =
    groups as typeof segment.value.conditionsGroups;
};

function normalizePurchasesCount(
  count: number | string | null | undefined | Array<string | null>
): number | null {
  if (count == null || count === "") return null;
  const raw = Array.isArray(count) ? count[0] : count;
  if (raw == null || raw === "") return null;
  const parsed = typeof raw === "number" ? raw : parseInt(String(raw), 10);
  return Number.isInteger(parsed) && parsed >= 2 ? parsed : null;
}

function applyPurchasesBounds(
  minCount: number | string | null | undefined | Array<string | null>,
  maxCount: number | string | null | undefined | Array<string | null>
) {
  const min = normalizePurchasesCount(minCount);
  const max = normalizePurchasesCount(maxCount);
  filter.filter.min_purchases_count = min;
  filter.filter.max_purchases_count = max;
  if (segment.value.conditionsGroups[0]) {
    segment.value.conditionsGroups[0].minPurchasesCount = min;
    segment.value.conditionsGroups[0].maxPurchasesCount = max;
  }
}

function buildCreateQuery(): Record<string, string> {
  const query: Record<string, string> = {
    type: segment.value.type.value,
  };
  if (filter.stringFilter != "()") {
    query.filter = filter.stringFilter;
  }
  const group = segment.value.conditionsGroups[0];
  const minCount = group.minPurchasesCount;
  const maxCount = group.maxPurchasesCount;
  if (minCount != null && Number.isInteger(minCount) && minCount >= 2) {
    query.min_purchases_count = String(minCount);
  }
  if (maxCount != null && Number.isInteger(maxCount) && maxCount >= 2) {
    query.max_purchases_count = String(maxCount);
  }
  return query;
}

const onTypeChange = () => {
  if (segment.value.type.value == "probability_of_purchase") {
    segment.value.conditionsGroups.forEach((group) => {
      group.brand = [];
      group.shop = [];
    });
  }
};

const setSegmentById = (cloneSegmentId: number, isDuplicate: boolean) => {
  isLoadingData.value = true;
  segmentStore
    .getSegment(cloneSegmentId)
    .then((cloneSegment) => {
      if (cloneSegment) {
        segment.value.name = isDuplicate
          ? cloneSegment.name + " (Копия)"
          : cloneSegment.name;
        segment.value.type = types.value.filter(
          (t) => t.value == cloneSegment.type
        )[0];

        if (cloneSegment.rich && !isDuplicate) {
          emit("updateAudienceCount", cloneSegment.rich.rich ?? null);

          emit(
            "updateSegmentCost",
            cloneSegment.rich.cost
              ? cloneSegment.rich.cost / 100 // Конвертируем копейки в рубли
              : null
          );
        }

        const ageMappings =
          agesStore.itemList.length > 0
            ? createAgeMappings(agesStore.itemList)
            : undefined;
        const groups = filter.getSegmentConditionsByFilter(
          cloneSegment.filter.filters_by_ids,
          ageMappings
        );
        if (cloneSegment.filter.filters_for_db) {
          const dbGroups = filter.getSegmentConditionsByFilter(
            cloneSegment.filter.filters_for_db,
            ageMappings
          );
          if (groups[0] && dbGroups[0]) {
            groups[0].total = dbGroups[0].total;
            groups[0].maxTotal = dbGroups[0].maxTotal;
          }
        }
        setFilterGroup(groups);
        applyPurchasesBounds(
          cloneSegment.filter.min_purchases_count,
          cloneSegment.filter.max_purchases_count
        );
      }
    })
    .finally(() => {
      isLoadingData.value = false;
    });
};

const createSegment = () => {
  const boundsError = validateSegmentBounds(segment.value.conditionsGroups[0]);
  if (
    (segment.value.conditionsGroups[0].isFixedDate &&
      !isValidPeriod(segment.value.conditionsGroups[0].period)) ||
    (segment.value.conditionsGroups[0].isFlexibleDate &&
      !isValidFlexiblePeriod(segment.value.conditionsGroups[0].flexible_period))
  )
    rootGetters.toast.show(
      "warn",
      "Ошибка",
      `Проверьте, что дата начала периода указана и она меньше, чем дата окончания.`
    );
  else if (boundsError) {
    rootGetters.toast.show("warn", "Ошибка", boundsError);
  } else if (
    props.audienceCount === null ||
    props.audienceCount < 100_000 ||
    props.audienceCount > 6_000_000
  ) {
    rootGetters.toast.show(
      "warn",
      "Ошибка",
      `Пересчитайте количество аудитории и убедитесь, что в сегменте не менее 100 тысяч пользователей и не более 6 миллионов.`
    );
  } else {
    const segmentToCreation = {
      name: segment.value.name,
      type: segment.value.type.value,
      filter: getFilterWithCategories(
        filter.filter,
        categoryStore.categoriesMap
      ),
      rich: props.audienceCount,
      cost:
        props.segmentCost !== null
          ? Math.round(props.segmentCost * 100) // Конвертируем рубли в копейки
          : 0,
    };

    emit("setLoading", true);

    segmentStore
      .createSegment(segmentToCreation)
      .then(() => {
        router.push({ name: "listSegments" });
        setTimeout(() => {
          segmentStore.activeFirst = false;
        }, 5000);
      })
      .catch((err) => {
        if (err.response && err.response.status == 403)
          rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
      })
      .finally(() => {
        emit("setLoading", false);
      });
  }
};

const createSegmentFromDialog = () => {
  blockedRouterButton.value = true;
  createSegment();
};

const confirmLeaving = () => {
  blockedRouterButton.value = false;
  confirmVisible.value = true;
};

const exitLeaveDialog = () => {
  router.push(toRouter.value);
};

const sendFilterToParent = () => {
  emit("setFilter", filter.filter);
};

watch(
  isReadyToCount,
  (newValue) => {
    emit("updateIsReadyToCount", newValue);
  },
  { immediate: true }
);

watch(
  countDisabledReason,
  (reason) => {
    emit("updateCountDisabledReason", reason);
  },
  { immediate: true }
);

defineExpose({
  createSegment,
});
</script>

<style lang="scss" scoped>
.form-filter {
  flex: 1;
  max-width: calc(100% - 240px - 30px - 36px);
  min-width: 780px;
}

.some-inputs {
  max-width: 100%;
}

.input-container {
  max-width: calc(50% - 4px);
  width: calc(50% - 4px);
}

.small-label {
  color: #a19cab;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.43rem;
  padding-bottom: 4px;
  padding-left: 4px;
}

.info-block {
  .info {
    font-size: 0.85rem;
    padding-top: 1px;
  }

  .text {
    font-size: 0.85rem;
    line-height: 1rem;
    padding-left: 8px;
  }

  padding-bottom: 14px;
}

.field-error {
  color: #dc2626;
  padding-bottom: 14px;

  .pi {
    font-size: 0.85rem;
    padding-top: 1px;
  }

  .text {
    font-size: 0.85rem;
    line-height: 1rem;
    padding-left: 8px;
  }
}

.info-block.alone {
  .info {
    font-size: 0.95rem;
  }

  .text {
    font-size: 0.95rem;
    line-height: 1.2rem;
    padding-left: 10px;

    p {
      margin-top: 0;
    }
  }

  .pi {
    padding-top: 2px;
  }

  padding-bottom: 0;
}

.gender-filter-section {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 16px;
  margin-top: 4px;
}

.gender-filter-label {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.4rem;
  margin-bottom: 12px;
  display: block;
}

.female-male-container {
  display: flex;
  gap: 24px;
  align-items: center;
}

.age-container {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: nowrap;
}

.age-divider {
  width: 1px;
  height: 24px;
  background-color: #e0e0e0;
  flex-shrink: 0;
}

.gender-option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(108, 117, 125, 0.1);
  }
}

.gender-checkbox-label {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin-left: 8px;
  cursor: pointer;
  user-select: none;
}

:deep(.p-inputtext:disabled),
:deep(.p-dropdown.p-disabled),
:deep(.p-multiselect.p-disabled) {
  background-color: $page-background-color;
}

.icon-right {
  position: relative;
  top: 2px;
  left: 5px;
}
</style>
